import {Injectable} from '@angular/core';
import {AbstractFindOneByIdService} from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {MedicalSportRepository} from './ngrx/medicalSport.repository';
import {MedicalSportDataServiceAdapter} from './ngrx/medicalSportDataService.adapter';
import {MedicalRecordSportModel} from '../../api/model/medicalRecordSport.model';

@Injectable()
export class MedicalSportFindOneService
    extends AbstractFindOneByIdService<MedicalRecordSportModel, MedicalRecordSportModel> {

    constructor(public repository: MedicalSportRepository,
                public dataServiceAdapter: MedicalSportDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
